const defaultTheme = {
    "primary": "#f0ad4e",
    "secondary": "#6c757d",
    "body-bg": "#fff",
    "body-color": "#212529"
};

export function applyTheme(theme = {}) {
    const themeObj = { ...defaultTheme, ...theme };

    Object.entries(themeObj).forEach(([key, value]) => {
        const normalized = value.startsWith("#") ? value : `#${value}`;
        document.documentElement.style.setProperty(`--bs-${key}`, normalized);

        // 👇 also set the RGB variant if Bootstrap expects it
        if (key === "primary" || key === "secondary" || key === "success" || key === "danger" || key === "warning" || key === "info" || key === "light" || key === "dark") {
            const rgb = hexToRgb(normalized); // e.g. "#ff0000" → "255, 0, 0"
            if (rgb) {
                document.documentElement.style.setProperty(`--bs-${key}-rgb`, rgb);
            }
        }

        if (key === "background") {
            // apply to <html>
            document.documentElement.style.backgroundColor = normalized;

            // apply to <body>
            document.body.style.backgroundColor = normalized;

            // apply to #root
            const rootEl = document.getElementById("root");
            if (rootEl) {
                rootEl.style.backgroundColor = normalized;
            }
        }

        if (key === "backgroundText") {
            const css = `.BackgroundText { color: ${normalized} !important; }`;
            let styleTag = document.getElementById("theme-backgroundText-style");
            if (!styleTag) {
                styleTag = document.createElement("style");
                styleTag.id = "theme-backgroundText-style";
                document.head.appendChild(styleTag);
            }
            styleTag.innerHTML = css;
        }

        if(key === "primaryText"){
            const css = `.primaryText { color: ${normalized} !important; }`;
            let styleTag = document.getElementById("theme-primaryText-style");
            if (!styleTag) {
                styleTag = document.createElement("style");
                styleTag.id = "theme-primaryText-style";
                document.head.appendChild(styleTag);
            }
            styleTag.innerHTML = css;
        }

        if (key === "blockText") {
            const css = `.card { color: ${normalized} !important; }`;
            let styleTag = document.getElementById("theme-blockText-style");
            if (!styleTag) {
                styleTag = document.createElement("style");
                styleTag.id = "theme-blockText-style";
                document.head.appendChild(styleTag);
            }
            styleTag.innerHTML = css;
        }


        if (key === "modal") {
            const css = `.modal-content { background-color: ${normalized} !important; }`;
            let styleTag = document.getElementById("theme-modal-style");
            if (!styleTag) {
                styleTag = document.createElement("style");
                styleTag.id = "theme-modal-style";
                document.head.appendChild(styleTag);
            }
            styleTag.innerHTML = css;
        }

        if (key === "modalText") {
            const css = `.modal-content { color: ${normalized} !important; }`;
            let styleTag = document.getElementById("theme-modalText-style");
            if (!styleTag) {
                styleTag = document.createElement("style");
                styleTag.id = "theme-modalText-style";
                document.head.appendChild(styleTag);
            }
            styleTag.innerHTML = css;
        }


        if (key === "header") {
            document.documentElement.style.setProperty("--bs-header-bg", normalized);
        }

        if(key === "secondaryText"){
            const css = `.secondaryText { color: ${normalized} !important; }`;
            let styleTag = document.getElementById("theme-secondaryText-style");
            if (!styleTag) {
                styleTag = document.createElement("style");
                styleTag.id = "theme-secondaryText-style";
                document.head.appendChild(styleTag);
            }
            styleTag.innerHTML = css;
        }

        if (key === "block") {
            // Override Bootstrap's "light" slot with whatever block is
            document.documentElement.style.setProperty("--bs-light", normalized);

            // optional: also override the rgb variant for opacity utilities
            const rgb = hexToRgb(normalized);
            if (rgb) {
                document.documentElement.style.setProperty("--bs-light-rgb", rgb);
            }
        }

        if(key === "headerText"){
            document.documentElement.style.setProperty("--bs-headerText", normalized);
        }



    });
}

function hexToRgb(hex) {
    const cleaned = hex.replace("#", "");
    if (cleaned.length === 3) {
        const r = parseInt(cleaned[0] + cleaned[0], 16);
        const g = parseInt(cleaned[1] + cleaned[1], 16);
        const b = parseInt(cleaned[2] + cleaned[2], 16);
        return `${r}, ${g}, ${b}`;
    }
    if (cleaned.length === 6) {
        const r = parseInt(cleaned.substring(0, 2), 16);
        const g = parseInt(cleaned.substring(2, 4), 16);
        const b = parseInt(cleaned.substring(4, 6), 16);
        return `${r}, ${g}, ${b}`;
    }
    return null;
}
